module.exports = __webpack_public_path__ + "img/UTREDF-3.ae68f393.jpg";